var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "employees-card-bottom" }, [
        _c("div", { staticClass: "main" }, [
          _c("div", { staticClass: "title" }, [_vm._v("公司介绍")]),
          _vm._v(" "),
          _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }